import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = guest, object = logged in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Skip /me probe on truly public routes (tenant landing pages, public tracking) to avoid 401 noise.
        // Marketing home "/" still probes so we can redirect logged-in users to their dashboard.
        const path = typeof window !== "undefined" ? window.location.pathname : "";
        if (path.startsWith("/t/") || path.startsWith("/track") || path.startsWith("/legal")) {
            setUser(false);
            setLoading(false);
            return;
        }
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(false);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const registerTenant = async (payload) => {
        const { data } = await api.post("/auth/register-tenant", payload);
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        setUser(false);
    };

    const refreshMe = async () => {
        const { data } = await api.get("/auth/me");
        setUser(data);
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, registerTenant, logout, refreshMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
